/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisPositionsBatchRequest } from '../../models/platform-ephemeris-positions-batch-request';
import { PlatformEphemerisPositionsBatchResponse } from '../../models/platform-ephemeris-positions-batch-response';

export interface PostEphemerisPositionsBatch$Params {
      body: PlatformEphemerisPositionsBatchRequest
}

export function postEphemerisPositionsBatch(http: HttpClient, rootUrl: string, params: PostEphemerisPositionsBatch$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisPositionsBatchResponse>> {
  const rb = new RequestBuilder(rootUrl, postEphemerisPositionsBatch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisPositionsBatchResponse>;
    })
  );
}

postEphemerisPositionsBatch.PATH = '/api/Ephemeris/positions/batch';
